import {useNavigate} from "react-router-dom";

import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

const EntityCreateButton = ({basePath = "", onClick = null}) => {
    const navigate = useNavigate();

    return (
        <Button
            variant="contained"
            onClick={() => {
                onClick ? onClick() : navigate(`/${basePath}/new`);
            }}
            startIcon={<AddIcon />}
        >
            Criar
        </Button>
    );
};
export default EntityCreateButton;
